import { Effect } from '../../../../core/action';
import { Auth as AuthTools } from '../../../tools';

export default function (): Effect {
    return async (): Promise<void> => {
        return AuthTools.signInWithTwitter();
    };
}
